import { _isStart, _isEnd, } from '../route-model/RoutePoint';
import { _$lineGroup, _$editMarkerGroup, } from "../route-service/event-handler-groups";
import { _updateRouteColors, } from '../route-service/route-colors';
import { _$markerIcons, } from '../route-view/route-feature-settings';
const _u_appendPoint = ({ ip: innerPoint, op: outerPoint, l: newLine, r: route, }) => {
    const $outerMarker = outerPoint.m(), outerLatLng = $outerMarker.getLatLng();
    route.set({ e: outerPoint });
    route.ev().setLatLng(outerLatLng);
    innerPoint.set({ ol: newLine, np: outerPoint });
    const endBecomesCorner = !_isStart(innerPoint);
    if (endBecomesCorner) {
        innerPoint.m().setIcon(_$markerIcons.c);
    }
    _finishAddingPoint(route, $outerMarker, newLine, newLine.len());
}, _u_removeEndPoint = ({ ip: innerPoint, op: outerPoint, l: line, r: route, }) => {
    const $innerMarker = innerPoint.m(), innerLatLng = $innerMarker.getLatLng();
    route.set({ e: innerPoint });
    route.ev().setLatLng(innerLatLng);
    innerPoint.set({ ol: null, np: null });
    const innerIsCorner = !_isStart(innerPoint);
    if (innerIsCorner) {
        $innerMarker.setIcon(_$markerIcons.e);
    }
    _finishRemovingPoint(route, outerPoint.m(), line, -line.len());
}, _u_prependPoint = ({ ip: innerPoint, op: outerPoint, l: newLine, r: route, }) => {
    const $outerMarker = outerPoint.m(), outerLatLng = $outerMarker.getLatLng();
    route.set({ s: outerPoint });
    route.sv().setLatLng(outerLatLng);
    innerPoint.set({ pp: outerPoint, il: newLine });
    const startBecomesCorner = !_isEnd(innerPoint);
    if (startBecomesCorner) {
        innerPoint.m().setIcon(_$markerIcons.c);
    }
    _finishAddingPoint(route, $outerMarker, newLine, newLine.len());
}, _u_removeStartPoint = ({ ip: innerPoint, op: outerPoint, l: line, r: route, }) => {
    const $innerMarker = innerPoint.m(), innerLatLng = $innerMarker.getLatLng();
    route.set({ s: innerPoint });
    route.sv().setLatLng(innerLatLng);
    innerPoint.set({ pp: null, il: null });
    $innerMarker.setIcon(_$markerIcons.s);
    _finishRemovingPoint(route, outerPoint.m(), line, -line.len());
}, _u_insertPoint = ({ cp: cornerPoint, pp: prevPoint, np: nextPoint, il: existingLine, ol: outgoingLine, r: route, }) => {
    const oldLength = existingLine.len();
    existingLine.set(false, cornerPoint);
    prevPoint.set({ np: cornerPoint });
    nextPoint.set({ pp: cornerPoint, il: outgoingLine });
    const newLength = existingLine.len() + outgoingLine.len(), lengthChange = newLength - oldLength;
    _finishAddingPoint(route, cornerPoint.m(), outgoingLine, lengthChange);
}, _u_removeCornerPoint = ({ cp: cornerPoint, pp: prevPoint, np: nextPoint, il: incomingLine, ol: outgoingLine, r: route, }) => {
    const oldLength = incomingLine.len() + outgoingLine.len();
    incomingLine.set(false, nextPoint);
    prevPoint.set({ np: nextPoint });
    nextPoint.set({ pp: prevPoint, il: incomingLine });
    const newLength = incomingLine.len(), lengthChange = newLength - oldLength;
    _finishRemovingPoint(route, cornerPoint.m(), outgoingLine, lengthChange);
}, _finishAddingPoint = (route, $marker, line, lengthChange) => {
    $marker.addTo(_$editMarkerGroup);
    line.ml().addTo(_$lineGroup);
    route.inc();
    route.len().add(lengthChange);
    _updateRouteColors(route);
}, _finishRemovingPoint = (route, $outerMarker, line, lengthChange) => {
    $outerMarker.removeFrom(_$editMarkerGroup);
    line.ml().removeFrom(_$lineGroup);
    route.dec();
    route.len().add(lengthChange);
    _updateRouteColors(route);
};
export { _u_appendPoint, _u_removeEndPoint, _u_prependPoint, _u_removeStartPoint, _u_insertPoint, _u_removeCornerPoint, };
